// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Photo20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Photo20: FC<Photo20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
            viewBox="0 0 20 20"
        >
            <path d="M4.5 17q-.618 0-1.06-.448A1.45 1.45 0 0 1 3 15.5v-11q0-.604.44-1.052A1.43 1.43 0 0 1 4.5 3h11q.619 0 1.06.448.44.449.44 1.052v11q0 .604-.44 1.052A1.43 1.43 0 0 1 15.5 17zm0-1.5h11v-11h-11zm1-1.5h9l-3-4-2.25 3-1.5-2z" />
        </svg>
    );
};

export default Photo20;
